import React from 'react';
import { Tabs, Card } from 'antd';
import { BacklinksResourcePaths, BacklinksTabsSettings } from '../types';
import BacklinksResults from './BacklinksResults';

type Props = {
	domain: string;
	settings: BacklinksTabsSettings;
};

/**
 * This component will have the tabs declared in the settings object, holding a BacklinksResults for each of them
 * @param props A settings object that will declare the structure of the tabs (label, resource type, ordering
 * direction and ordering criteria) and a domain (example: eggnita.com)
 * @returns React component
 */
export default function BacklinksTabs({ domain, settings }: Props) {
	const { displayOrder, sections } = settings;

	return (
		<div className="backlinks-tabs">
			<Card>
				<Tabs type="card" tabBarGutter={10} destroyInactiveTabPane={true}>
					{displayOrder.map((section) => (
						<Tabs.TabPane tab={sections[section].label} key={section}>
							<BacklinksResults
								domain={domain}
								resourceType={sections[section].resource_type as keyof BacklinksResourcePaths}
								orderBy={sections[section].order_by}
								orderDir={sections[section].order_dir}
							/>
						</Tabs.TabPane>
					))}
				</Tabs>
			</Card>
		</div>
	);
}
